import cx from 'classnames';

export const PERSON_FOLDERS = ['pessoas', 'persons', 'people'];
export const folderPattern = new RegExp(`^(${PERSON_FOLDERS.join('|')})$`, 'i');

export const byTitle = (a, b) =>
  (a?.title || '').localeCompare(b?.title || '', 'pt', { sensitivity: 'base' });

export const ensureCompositionBase = ({
  path,
  content,
  lang = 'pt-br',
  contentType,
  ...props
}) => {
  const base = `/${lang.toLowerCase()}/composicao/`;
  if (!path) return base + '/';

  const norm = path.endsWith('/') ? path : path + '/';
  // Se o path já é a base, retorna ele mesmo.
  if (norm === base) return norm;

  const isCompositionBase = norm.startsWith(base);
  const isArea = content?.['@type'] === 'Area' || contentType === 'Area';
  // Se está dentro de /{lang}/composicao/ e o tipo é 'Area' mantém norm;
  if (isCompositionBase && isArea) return norm;

  const parentType = content?.parent?.['@type'];
  // Se tiver na base e o pai for do tipo area retorna o path um nível acima
  if (isCompositionBase && parentType === 'Area') {
    const parts = norm.split('/').filter(Boolean);
    parts.pop();
    return '/' + parts.join('/') + '/';
  }

  if (!parentType && norm.endsWith('/add/') && isCompositionBase && !isArea) {
    return norm;
  }

  return base;
};

export const personsGridClass = (personsPerRow, styles) =>
  cx(
    styles.personsList,
    personsPerRow === '1' && styles.one,
    personsPerRow === '2' && styles.two,
    personsPerRow === '3' && styles.three,
    personsPerRow === '4' && styles.four,
    personsPerRow === '5' && styles.five,
  );
